import React from 'react'
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

// Track deployed from branch in Google Analytics for Split Testing.
const branch = process.env.BRANCH;

// TODO: Thabang: Fix the commented stuff.
export default class SEOInfo extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    canonicalLink: PropTypes.string
  };

  static defaultProps = {
    canonicalLink: '/za'
  };

  makeLink = endPoint => {
    const url = (process.env.NODE_ENV === 'development') ? 'https://www.hippo.yocobeta.co.za' : 'https://www.yoco.co.za';
    return `${url}${endPoint}`
  };

  render() {
    console.log('NODE_ENV', process.env.NODE_ENV);
    return (
      <Helmet>
        <title>{this.props.title}</title>
        <meta name="description" content={this.props.description} />
        <link rel={'canonical'} href={this.makeLink(this.props.canonicalLink)} />
      </Helmet>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SEOInfo.js